import { useRouteLoaderData } from "react-router";

import { useGetEventMetricsByIdQuery } from "~/feature/event/eventApi";
import { useBackgroundError } from "~/hooks/useBackgroundError";
import type { EventLoaderData } from "~/loaders/event";

interface IUseEventMetricsProps {
  id: string;
}

export const useEventMetrics = ({ id }: IUseEventMetricsProps) => {
  const initialMetrics =
    (useRouteLoaderData("routes/event") as EventLoaderData | undefined)
      ?.metrics ?? undefined;

  const {
    data: queryData,
    isLoading,
    error,
  } = useGetEventMetricsByIdQuery(
    { id },
    {
      pollingInterval: 300_000,
      refetchOnFocus: true,
      refetchOnReconnect: true,
      skipPollingIfUnfocused: true,
    }
  );

  useBackgroundError(error);

  const data = queryData ?? initialMetrics;

  return {
    data,
    isLoading: isLoading && !data,
    isChangeUnavailable: !!error,
  };
};
